import { css } from "@linaria/core"

export const darkTheme = "(prefers-color-scheme: dark) and (prefers-color-scheme: no-preference)"

export const mobileBreakpoint = "only screen and (width <= 600px)"

export const ellipsis = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}

export const dropdownShadow = {
  boxShadow: "var(--dropdown-shadow-color) 0 4px 15px 0"
}

export const focusOutline = {
  outline: "2px solid var(--outline-color)",
  outlineOffset: "-2px"
}

export const rotate0 = {
  transform: "rotate(0deg)",
  transition: "transform 0.2s"
}

export const rotate45 = {
  transform: "rotate(45deg)",
  transition: "transform 0.2s"
}

export const rotate90 = {
  transform: "rotate(90deg)",
  transition: "transform 0.2s"
}

export const rotate180 = {
  transform: "rotate(180deg)",
  transition: "transform 0.2s"
}

export const Rotate0 = css`
  ${rotate0};
`

export const Rotate45 = css`
  ${rotate45};
`

export const Rotate90 = css`
  ${rotate90};
`

export const Rotate180 = css`
  ${rotate180};
`

export function importHighlightJsStyles() {
  const darkThemeQuery = window.matchMedia(darkTheme)

  function loadHighlightStyle(e: MediaQueryList | MediaQueryListEvent) {
    if (e.matches) {
      void import("highlight.js/styles/dark.css")
    } else {
      void import("highlight.js/styles/intellij-light.css")
    }
  }

  loadHighlightStyle(darkThemeQuery)

  darkThemeQuery.addEventListener("change", loadHighlightStyle)

  return () => darkThemeQuery.removeEventListener("change", loadHighlightStyle)
}
